import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material';
import GlobalFonts from 'layout/theme/GlobalFonts';
import { theme } from 'layout';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ThemeProvider theme={createTheme(theme)}>
        <GlobalFonts />
        <App />
    </ThemeProvider>
);
